import store from "@/store";
import { computed } from "vue";
import { HttpAxios } from "@/common/services/httpAxios";

export const infoDetails = computed(() => {
  return [
    {
      title: "Tokens",
      observation: [
        { label: "CAS token", text: store.getters["token/token"] },
        { label: "BFF token", text: HttpAxios.tokenBff },
      ],
    },
    {
      title: "Informações do usuário",
      observation: [{ label: "User", text: store.getters["user/user"] }],
    },
    {
      title: "Informações do account",
      observation: [
        {
          label: "Account",
          text: JSON.parse(localStorage.getItem("ACCOUNT") ?? "{}"),
        },
      ],
    },
  ];
});
